import { Fragment } from "react";
import { Link } from "react-router-dom";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import Rating from "../component/sidebar/rating";

const artTutors = [
    {
        imgUrl: "assets/images/art/artTutor1.png",
        imgAlt: "Painting Tutor",
        tutorName: "Anita Verma",
        expertise: "Painting – Watercolors, Acrylic, Oil Painting",
        experience: "8+ Years Experience",
        students: "150+ Students Trained",
        reviewCount: "15 reviews",
        profile: "/art-painting-tutor",
        btnText: "View Profile",
    },
    {
        imgUrl: "assets/images/art/artTutor2.png",
        imgAlt: "Sketching Tutor",
        tutorName: "Rohit Sharma",
        expertise: "Sketching – Pencil, Charcoal & Shading",
        experience: "7+ Years Experience",
        students: "120+ Students",
        reviewCount: "11 reviews",
        profile: "/art-sketching-tutor",
        btnText: "View Profile",
    },
    {
        imgUrl: "assets/images/art/artTutor3.png",
        imgAlt: "Coloring Tutor",
        tutorName: "Sujatha Rao",
        expertise: "Color Blending, Mandala & Creative Coloring",
        experience: "6+ Years Experience",
        students: "90+ Students",
        reviewCount: "10 reviews",
        profile: "/art-coloring-tutor",
        btnText: "View Profile",
    },
    {
        imgUrl: "assets/images/art/artTutor4.png",
        imgAlt: "Craft Tutor",
        tutorName: "Karthik Reddy",
        expertise: "Paper Craft, Clay Work & Creative Art",
        experience: "5+ Years Experience",
        students: "110+ Students",
        reviewCount: "13 reviews",
        profile: "/art-craft-tutor",
        btnText: "View Profile",
    },
];

const FineArts = () => {
    return (
        <Fragment>
            <Header />

            <div
                className="course-section padding-tb section-bg"
                style={{ backgroundColor: "#FFF9E8" }}
            >
                <div className="container" style={{ marginTop: 60 }}>
                    <div className="row g-4">

                        {/* ---------------- LEFT SIDE ADS ---------------- */}
                        <div className="col-lg-3 col-md-4">
                            <div className="ads-sidebar">
                                <h5 className="mb-3 text-center">🎨 Sponsored</h5>

                                <div className="ad-item mb-3">
                                    <img
                                        src="assets/images/art/paintingAd1.png"
                                        alt="Art ad 1"
                                        className="w-100 rounded shadow-sm"
                                    />
                                </div>

                                <div className="ad-item mb-3">
                                    <img
                                        src="assets/images/art/paintingAd2.png"
                                        alt="Art ad 2"
                                        className="w-100 rounded shadow-sm"
                                    />
                                </div>

                                <div className="ad-item">
                                    <img
                                        src="assets/images/art/paintingAd3.png"
                                        alt="Art ad 3"
                                        className="w-100 rounded shadow-sm"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* ---------------- RIGHT SIDE CONTENT ---------------- */}
                        <div className="col-lg-9 col-md-8">
                            <div className="section-wrapper">

                                <div className="row g-4 justify-content-center row-cols-xl-2 row-cols-md-2 row-cols-1">
                                    {artTutors.map((tutor, i) => (
                                        <div className="col" key={i}>
                                            <div className="course-item shadow-sm rounded">
                                                <div className="course-inner">

                                                    {/* Tutor Image */}
                                                    <div className="course-thumb">
                                                        <img src={tutor.imgUrl} alt={tutor.imgAlt} />
                                                    </div>

                                                    {/* Tutor Details */}
                                                    <div className="course-content">
                                                        <div className="course-category">
                                                            <div className="course-reiew">
                                                                <Rating />
                                                                <span className="ratting-count">
                                                                    {" "}
                                                                    {tutor.reviewCount}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <Link to={tutor.profile}>
                                                            <h4>{tutor.tutorName}</h4>
                                                        </Link>

                                                        <p style={{ color: "black", margin: "5px 0" }}>
                                                            🎨 {tutor.expertise}
                                                        </p>

                                                        <p style={{ color: "black", margin: "5px 0" }}>
                                                            ⭐ {tutor.experience}
                                                        </p>

                                                        <p style={{ color: "black", margin: "5px 0" }}>
                                                            👥 {tutor.students}
                                                        </p>

                                                        {/* Footer */}
                                                        <div className="course-footer">
                                                            <div></div>
                                                            <div className="course-btn">
                                                                <Link to={tutor.profile} className="lab-btn-text">
                                                                    {tutor.btnText}{" "}
                                                                    <i className="icofont-external-link"></i>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </Fragment>
    );
};

export default FineArts;
